import { h as J, defineComponent as st, isReactive as Ut, Teleport as Vt, Fragment as It, watch as Rt, onMounted as jt } from "vue";
const Ht = (e, t) => (n, o) => {
  const i = {
    Component: J(t, o),
    wrapperElement: n
  };
  e(i);
};
class zt extends Error {
  constructor(t) {
    super(t), this.name = "[Schedule-X reactivity error]";
  }
}
const Bi = st({
  name: "ScheduleXCalendar",
  props: {
    calendarApp: {
      type: Object,
      required: !0
    },
    customComponents: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      elId: "sx" + Math.random().toString(36).substr(2, 9),
      customComponentsMeta: []
    };
  },
  mounted() {
    if (Ut(this.calendarApp))
      throw new zt("calendarApp cannot be saved in a ref. Since this causes deep reactivity, it destroys the calendars internal reactivity. Save in a normal const or shallowRef");
    const e = {
      ...this.customComponents,
      ...this.$slots
    };
    for (const [t, n] of Object.entries(e))
      this.calendarApp._setCustomComponentFn(t, Ht(this.setCustomComponentMeta, n));
    this.calendarApp.render(document.getElementById(this.elId));
  },
  methods: {
    setCustomComponentMeta(e) {
      if (!(e.wrapperElement instanceof HTMLElement))
        return;
      const n = ({ wrapperElement: a }) => a instanceof HTMLElement, o = [
        ...this.customComponentsMeta.filter(n)
      ], i = e.wrapperElement.dataset.ccid, r = o.find(({ wrapperElement: a }) => a.dataset.ccid === i);
      r && o.splice(o.indexOf(r), 1), this.customComponentsMeta = [...o, e];
    }
  },
  render() {
    const e = this.customComponentsMeta.map(({ Component: t, wrapperElement: n }) => J(Vt, { to: n }, t));
    return J("div", {
      id: this.elId,
      class: "sx-vue-calendar-wrapper"
    }, J(It, {}, e));
  }
});
var pe, v, lt, ut, U, We, ct, Pe, dt, q = {}, _t = [], Bt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, fe = Array.isArray;
function A(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function vt(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function j(e, t, n) {
  var o, i, r, a = {};
  for (r in t) r == "key" ? o = t[r] : r == "ref" ? i = t[r] : a[r] = t[r];
  if (arguments.length > 2 && (a.children = arguments.length > 3 ? pe.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (r in e.defaultProps) a[r] === void 0 && (a[r] = e.defaultProps[r]);
  return se(e, a, o, i, null);
}
function se(e, t, n, o, i) {
  var r = { type: e, props: t, key: n, ref: o, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: i ?? ++lt, __i: -1, __u: 0 };
  return i == null && v.vnode != null && v.vnode(r), r;
}
function S(e) {
  return e.children;
}
function T(e, t) {
  this.props = e, this.context = t;
}
function H(e, t) {
  if (t == null) return e.__ ? H(e.__, e.__i + 1) : null;
  for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
  return typeof e.type == "function" ? H(e) : null;
}
function ht(e) {
  var t, n;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) {
      e.__e = e.__c.base = n.__e;
      break;
    }
    return ht(e);
  }
}
function Se(e) {
  (!e.__d && (e.__d = !0) && U.push(e) && !de.__r++ || We !== v.debounceRendering) && ((We = v.debounceRendering) || ct)(de);
}
function de() {
  var e, t, n, o, i, r, a, s, u;
  for (U.sort(Pe); e = U.shift(); ) e.__d && (t = U.length, o = void 0, r = (i = (n = e).__v).__e, s = [], u = [], (a = n.__P) && ((o = A({}, i)).__v = i.__v + 1, v.vnode && v.vnode(o), Ce(a, o, i, n.__n, a.ownerSVGElement !== void 0, 32 & i.__u ? [r] : null, s, r ?? H(i), !!(32 & i.__u), u), o.__.__k[o.__i] = o, mt(s, o, u), o.__e != r && ht(o)), U.length > t && U.sort(Pe));
  de.__r = 0;
}
function pt(e, t, n, o, i, r, a, s, u, c, d) {
  var l, _, h, m, f, g = o && o.__k || _t, y = t.length;
  for (n.__d = u, Kt(n, t, g), u = n.__d, l = 0; l < y; l++) (h = n.__k[l]) != null && typeof h != "boolean" && typeof h != "function" && (_ = h.__i === -1 ? q : g[h.__i] || q, h.__i = l, Ce(e, h, _, i, r, a, s, u, c, d), m = h.__e, h.ref && _.ref != h.ref && (_.ref && Oe(_.ref, null, h), d.push(h.ref, h.__c || m, h)), f == null && m != null && (f = m), 65536 & h.__u || _.__k === h.__k ? u = ft(h, u, e) : typeof h.type == "function" && h.__d !== void 0 ? u = h.__d : m && (u = m.nextSibling), h.__d = void 0, h.__u &= -196609);
  n.__d = u, n.__e = f;
}
function Kt(e, t, n) {
  var o, i, r, a, s, u = t.length, c = n.length, d = c, l = 0;
  for (e.__k = [], o = 0; o < u; o++) (i = e.__k[o] = (i = t[o]) == null || typeof i == "boolean" || typeof i == "function" ? null : typeof i == "string" || typeof i == "number" || typeof i == "bigint" || i.constructor == String ? se(null, i, null, null, i) : fe(i) ? se(S, { children: i }, null, null, null) : i.constructor === void 0 && i.__b > 0 ? se(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) != null ? (i.__ = e, i.__b = e.__b + 1, s = Gt(i, n, a = o + l, d), i.__i = s, r = null, s !== -1 && (d--, (r = n[s]) && (r.__u |= 131072)), r == null || r.__v === null ? (s == -1 && l--, typeof i.type != "function" && (i.__u |= 65536)) : s !== a && (s === a + 1 ? l++ : s > a ? d > u - a ? l += s - a : l-- : l = s < a && s == a - 1 ? s - a : 0, s !== o + l && (i.__u |= 65536))) : (r = n[o]) && r.key == null && r.__e && (r.__e == e.__d && (e.__d = H(r)), we(r, r, !1), n[o] = null, d--);
  if (d) for (o = 0; o < c; o++) (r = n[o]) != null && !(131072 & r.__u) && (r.__e == e.__d && (e.__d = H(r)), we(r, r));
}
function ft(e, t, n) {
  var o, i;
  if (typeof e.type == "function") {
    for (o = e.__k, i = 0; o && i < o.length; i++) o[i] && (o[i].__ = e, t = ft(o[i], t, n));
    return t;
  }
  return e.__e != t && (n.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function _e(e, t) {
  return t = t || [], e == null || typeof e == "boolean" || (fe(e) ? e.some(function(n) {
    _e(n, t);
  }) : t.push(e)), t;
}
function Gt(e, t, n, o) {
  var i = e.key, r = e.type, a = n - 1, s = n + 1, u = t[n];
  if (u === null || u && i == u.key && r === u.type) return n;
  if (o > (u != null && !(131072 & u.__u) ? 1 : 0)) for (; a >= 0 || s < t.length; ) {
    if (a >= 0) {
      if ((u = t[a]) && !(131072 & u.__u) && i == u.key && r === u.type) return a;
      a--;
    }
    if (s < t.length) {
      if ((u = t[s]) && !(131072 & u.__u) && i == u.key && r === u.type) return s;
      s++;
    }
  }
  return -1;
}
function Ue(e, t, n) {
  t[0] === "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || Bt.test(t) ? n : n + "px";
}
function ie(e, t, n, o, i) {
  var r;
  e: if (t === "style") if (typeof n == "string") e.style.cssText = n;
  else {
    if (typeof o == "string" && (e.style.cssText = o = ""), o) for (t in o) n && t in n || Ue(e.style, t, "");
    if (n) for (t in n) o && n[t] === o[t] || Ue(e.style, t, n[t]);
  }
  else if (t[0] === "o" && t[1] === "n") r = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + r] = n, n ? o ? n.u = o.u : (n.u = Date.now(), e.addEventListener(t, r ? Ie : Ve, r)) : e.removeEventListener(t, r ? Ie : Ve, r);
  else {
    if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t !== "rowSpan" && t !== "colSpan" && t !== "role" && t in e) try {
      e[t] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n == null || n === !1 && t[4] !== "-" ? e.removeAttribute(t) : e.setAttribute(t, n));
  }
}
function Ve(e) {
  var t = this.l[e.type + !1];
  if (e.t) {
    if (e.t <= t.u) return;
  } else e.t = Date.now();
  return t(v.event ? v.event(e) : e);
}
function Ie(e) {
  return this.l[e.type + !0](v.event ? v.event(e) : e);
}
function Ce(e, t, n, o, i, r, a, s, u, c) {
  var d, l, _, h, m, f, g, y, b, $, te, K, Fe, ne, De, Y = t.type;
  if (t.constructor !== void 0) return null;
  128 & n.__u && (u = !!(32 & n.__u), r = [s = t.__e = n.__e]), (d = v.__b) && d(t);
  e: if (typeof Y == "function") try {
    if (y = t.props, b = (d = Y.contextType) && o[d.__c], $ = d ? b ? b.props.value : d.__ : o, n.__c ? g = (l = t.__c = n.__c).__ = l.__E : ("prototype" in Y && Y.prototype.render ? t.__c = l = new Y(y, $) : (t.__c = l = new T(y, $), l.constructor = Y, l.render = Zt), b && b.sub(l), l.props = y, l.state || (l.state = {}), l.context = $, l.__n = o, _ = l.__d = !0, l.__h = [], l._sb = []), l.__s == null && (l.__s = l.state), Y.getDerivedStateFromProps != null && (l.__s == l.state && (l.__s = A({}, l.__s)), A(l.__s, Y.getDerivedStateFromProps(y, l.__s))), h = l.props, m = l.state, l.__v = t, _) Y.getDerivedStateFromProps == null && l.componentWillMount != null && l.componentWillMount(), l.componentDidMount != null && l.__h.push(l.componentDidMount);
    else {
      if (Y.getDerivedStateFromProps == null && y !== h && l.componentWillReceiveProps != null && l.componentWillReceiveProps(y, $), !l.__e && (l.shouldComponentUpdate != null && l.shouldComponentUpdate(y, l.__s, $) === !1 || t.__v === n.__v)) {
        for (t.__v !== n.__v && (l.props = y, l.state = l.__s, l.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function(oe) {
          oe && (oe.__ = t);
        }), te = 0; te < l._sb.length; te++) l.__h.push(l._sb[te]);
        l._sb = [], l.__h.length && a.push(l);
        break e;
      }
      l.componentWillUpdate != null && l.componentWillUpdate(y, l.__s, $), l.componentDidUpdate != null && l.__h.push(function() {
        l.componentDidUpdate(h, m, f);
      });
    }
    if (l.context = $, l.props = y, l.__P = e, l.__e = !1, K = v.__r, Fe = 0, "prototype" in Y && Y.prototype.render) {
      for (l.state = l.__s, l.__d = !1, K && K(t), d = l.render(l.props, l.state, l.context), ne = 0; ne < l._sb.length; ne++) l.__h.push(l._sb[ne]);
      l._sb = [];
    } else do
      l.__d = !1, K && K(t), d = l.render(l.props, l.state, l.context), l.state = l.__s;
    while (l.__d && ++Fe < 25);
    l.state = l.__s, l.getChildContext != null && (o = A(A({}, o), l.getChildContext())), _ || l.getSnapshotBeforeUpdate == null || (f = l.getSnapshotBeforeUpdate(h, m)), pt(e, fe(De = d != null && d.type === S && d.key == null ? d.props.children : d) ? De : [De], t, n, o, i, r, a, s, u, c), l.base = t.__e, t.__u &= -161, l.__h.length && a.push(l), g && (l.__E = l.__ = null);
  } catch (oe) {
    t.__v = null, u || r != null ? (t.__e = s, t.__u |= u ? 160 : 32, r[r.indexOf(s)] = null) : (t.__e = n.__e, t.__k = n.__k), v.__e(oe, t, n);
  }
  else r == null && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = Jt(n.__e, t, n, o, i, r, a, u, c);
  (d = v.diffed) && d(t);
}
function mt(e, t, n) {
  t.__d = void 0;
  for (var o = 0; o < n.length; o++) Oe(n[o], n[++o], n[++o]);
  v.__c && v.__c(t, e), e.some(function(i) {
    try {
      e = i.__h, i.__h = [], e.some(function(r) {
        r.call(i);
      });
    } catch (r) {
      v.__e(r, i.__v);
    }
  });
}
function Jt(e, t, n, o, i, r, a, s, u) {
  var c, d, l, _, h, m, f, g = n.props, y = t.props, b = t.type;
  if (b === "svg" && (i = !0), r != null) {
    for (c = 0; c < r.length; c++) if ((h = r[c]) && "setAttribute" in h == !!b && (b ? h.localName === b : h.nodeType === 3)) {
      e = h, r[c] = null;
      break;
    }
  }
  if (e == null) {
    if (b === null) return document.createTextNode(y);
    e = i ? document.createElementNS("http://www.w3.org/2000/svg", b) : document.createElement(b, y.is && y), r = null, s = !1;
  }
  if (b === null) g === y || s && e.data === y || (e.data = y);
  else {
    if (r = r && pe.call(e.childNodes), g = n.props || q, !s && r != null) for (g = {}, c = 0; c < e.attributes.length; c++) g[(h = e.attributes[c]).name] = h.value;
    for (c in g) h = g[c], c == "children" || (c == "dangerouslySetInnerHTML" ? l = h : c === "key" || c in y || ie(e, c, null, h, i));
    for (c in y) h = y[c], c == "children" ? _ = h : c == "dangerouslySetInnerHTML" ? d = h : c == "value" ? m = h : c == "checked" ? f = h : c === "key" || s && typeof h != "function" || g[c] === h || ie(e, c, h, g[c], i);
    if (d) s || l && (d.__html === l.__html || d.__html === e.innerHTML) || (e.innerHTML = d.__html), t.__k = [];
    else if (l && (e.innerHTML = ""), pt(e, fe(_) ? _ : [_], t, n, o, i && b !== "foreignObject", r, a, r ? r[0] : n.__k && H(n, 0), s, u), r != null) for (c = r.length; c--; ) r[c] != null && vt(r[c]);
    s || (c = "value", m !== void 0 && (m !== e[c] || b === "progress" && !m || b === "option" && m !== g[c]) && ie(e, c, m, g[c], !1), c = "checked", f !== void 0 && f !== e[c] && ie(e, c, f, g[c], !1));
  }
  return e;
}
function Oe(e, t, n) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (o) {
    v.__e(o, n);
  }
}
function we(e, t, n) {
  var o, i;
  if (v.unmount && v.unmount(e), (o = e.ref) && (o.current && o.current !== e.__e || Oe(o, null, t)), (o = e.__c) != null) {
    if (o.componentWillUnmount) try {
      o.componentWillUnmount();
    } catch (r) {
      v.__e(r, t);
    }
    o.base = o.__P = null, e.__c = void 0;
  }
  if (o = e.__k) for (i = 0; i < o.length; i++) o[i] && we(o[i], t, n || typeof e.type != "function");
  n || e.__e == null || vt(e.__e), e.__ = e.__e = e.__d = void 0;
}
function Zt(e, t, n) {
  return this.constructor(e, n);
}
function Me(e, t, n) {
  var o, i, r, a;
  v.__ && v.__(e, t), i = (o = typeof n == "function") ? null : t.__k, r = [], a = [], Ce(t, e = (!o && n || t).__k = j(S, null, [e]), i || q, q, t.ownerSVGElement !== void 0, !o && n ? [n] : i ? null : t.firstChild ? pe.call(t.childNodes) : null, r, !o && n ? n : i ? i.__e : t.firstChild, o, a), mt(r, e, a);
}
function qt(e, t) {
  var n = { __c: t = "__cC" + dt++, __: e, Consumer: function(o, i) {
    return o.children(i);
  }, Provider: function(o) {
    var i, r;
    return this.getChildContext || (i = [], (r = {})[t] = this, this.getChildContext = function() {
      return r;
    }, this.shouldComponentUpdate = function(a) {
      this.props.value !== a.value && i.some(function(s) {
        s.__e = !0, Se(s);
      });
    }, this.sub = function(a) {
      i.push(a);
      var s = a.componentWillUnmount;
      a.componentWillUnmount = function() {
        i.splice(i.indexOf(a), 1), s && s.call(a);
      };
    }), o.children;
  } };
  return n.Provider.__ = n.Consumer.contextType = n;
}
pe = _t.slice, v = { __e: function(e, t, n, o) {
  for (var i, r, a; t = t.__; ) if ((i = t.__c) && !i.__) try {
    if ((r = i.constructor) && r.getDerivedStateFromError != null && (i.setState(r.getDerivedStateFromError(e)), a = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, o || {}), a = i.__d), a) return i.__E = i;
  } catch (s) {
    e = s;
  }
  throw e;
} }, lt = 0, ut = function(e) {
  return e != null && e.constructor == null;
}, T.prototype.setState = function(e, t) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = A({}, this.state), typeof e == "function" && (e = e(A({}, n), this.props)), e && A(n, e), e != null && this.__v && (t && this._sb.push(t), Se(this));
}, T.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), Se(this));
}, T.prototype.render = S, U = [], ct = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Pe = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, de.__r = 0, dt = 0;
var Xt = 0;
function p(e, t, n, o, i, r) {
  var a, s, u = {};
  for (s in t) s == "ref" ? a = t[s] : u[s] = t[s];
  var c = { type: e, props: u, key: n, ref: a, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --Xt, __i: -1, __u: 0, __source: i, __self: r };
  if (typeof e == "function" && (a = e.defaultProps)) for (s in a) u[s] === void 0 && (u[s] = a[s]);
  return v.vnode && v.vnode(c), c;
}
var z, D, ke, Re, Ye = 0, yt = [], le = [], je = v.__b, He = v.__r, ze = v.diffed, Be = v.__c, Ke = v.unmount;
function me(e, t) {
  v.__h && v.__h(D, e, Ye || t), Ye = 0;
  var n = D.__H || (D.__H = { __: [], __h: [] });
  return e >= n.__.length && n.__.push({ __V: le }), n.__[e];
}
function C(e) {
  return Ye = 1, Qt(gt, e);
}
function Qt(e, t, n) {
  var o = me(z++, 2);
  if (o.t = e, !o.__c && (o.__ = [n ? n(t) : gt(void 0, t), function(s) {
    var u = o.__N ? o.__N[0] : o.__[0], c = o.t(u, s);
    u !== c && (o.__N = [c, o.__[1]], o.__c.setState({}));
  }], o.__c = D, !D.u)) {
    var i = function(s, u, c) {
      if (!o.__c.__H) return !0;
      var d = o.__c.__H.__.filter(function(_) {
        return _.__c;
      });
      if (d.every(function(_) {
        return !_.__N;
      })) return !r || r.call(this, s, u, c);
      var l = !1;
      return d.forEach(function(_) {
        if (_.__N) {
          var h = _.__[0];
          _.__ = _.__N, _.__N = void 0, h !== _.__[0] && (l = !0);
        }
      }), !(!l && o.__c.props === s) && (!r || r.call(this, s, u, c));
    };
    D.u = !0;
    var r = D.shouldComponentUpdate, a = D.componentWillUpdate;
    D.componentWillUpdate = function(s, u, c) {
      if (this.__e) {
        var d = r;
        r = void 0, i(s, u, c), r = d;
      }
      a && a.call(this, s, u, c);
    }, D.shouldComponentUpdate = i;
  }
  return o.__N || o.__;
}
function L(e, t) {
  var n = me(z++, 3);
  !v.__s && kt(n.__H, t) && (n.__ = e, n.i = t, D.__H.__h.push(n));
}
function Dt(e, t) {
  var n = me(z++, 7);
  return kt(n.__H, t) ? (n.__V = e(), n.i = t, n.__h = e, n.__V) : n.__;
}
function F(e) {
  var t = D.context[e.__c], n = me(z++, 9);
  return n.c = e, t ? (n.__ == null && (n.__ = !0, t.sub(D)), t.props.value) : e.__;
}
function en() {
  for (var e; e = yt.shift(); ) if (e.__P && e.__H) try {
    e.__H.__h.forEach(ue), e.__H.__h.forEach(Ne), e.__H.__h = [];
  } catch (t) {
    e.__H.__h = [], v.__e(t, e.__v);
  }
}
v.__b = function(e) {
  D = null, je && je(e);
}, v.__r = function(e) {
  He && He(e), z = 0;
  var t = (D = e.__c).__H;
  t && (ke === D ? (t.__h = [], D.__h = [], t.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.__V = le, n.__N = n.i = void 0;
  })) : (t.__h.forEach(ue), t.__h.forEach(Ne), t.__h = [], z = 0)), ke = D;
}, v.diffed = function(e) {
  ze && ze(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (yt.push(t) !== 1 && Re === v.requestAnimationFrame || ((Re = v.requestAnimationFrame) || tn)(en)), t.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.__V !== le && (n.__ = n.__V), n.i = void 0, n.__V = le;
  })), ke = D = null;
}, v.__c = function(e, t) {
  t.some(function(n) {
    try {
      n.__h.forEach(ue), n.__h = n.__h.filter(function(o) {
        return !o.__ || Ne(o);
      });
    } catch (o) {
      t.some(function(i) {
        i.__h && (i.__h = []);
      }), t = [], v.__e(o, n.__v);
    }
  }), Be && Be(e, t);
}, v.unmount = function(e) {
  Ke && Ke(e);
  var t, n = e.__c;
  n && n.__H && (n.__H.__.forEach(function(o) {
    try {
      ue(o);
    } catch (i) {
      t = i;
    }
  }), n.__H = void 0, t && v.__e(t, n.__v));
};
var Ge = typeof requestAnimationFrame == "function";
function tn(e) {
  var t, n = function() {
    clearTimeout(o), Ge && cancelAnimationFrame(t), setTimeout(e);
  }, o = setTimeout(n, 100);
  Ge && (t = requestAnimationFrame(n));
}
function ue(e) {
  var t = D, n = e.__c;
  typeof n == "function" && (e.__c = void 0, n()), D = t;
}
function Ne(e) {
  var t = D;
  e.__c = e.__(), D = t;
}
function kt(e, t) {
  return !e || e.length !== t.length || t.some(function(n, o) {
    return n !== e[o];
  });
}
function gt(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function nn(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function Je(e, t) {
  for (var n in e) if (n !== "__source" && !(n in t)) return !0;
  for (var o in t) if (o !== "__source" && e[o] !== t[o]) return !0;
  return !1;
}
function Ze(e) {
  this.props = e;
}
(Ze.prototype = new T()).isPureReactComponent = !0, Ze.prototype.shouldComponentUpdate = function(e, t) {
  return Je(this.props, e) || Je(this.state, t);
};
var qe = v.__b;
v.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), qe && qe(e);
};
var on = v.__e;
v.__e = function(e, t, n, o) {
  if (e.then) {
    for (var i, r = t; r = r.__; ) if ((i = r.__c) && i.__c) return t.__e == null && (t.__e = n.__e, t.__k = n.__k), i.__c(e, t);
  }
  on(e, t, n, o);
};
var Xe = v.unmount;
function bt(e, t, n) {
  return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(o) {
    typeof o.__c == "function" && o.__c();
  }), e.__c.__H = null), (e = nn({}, e)).__c != null && (e.__c.__P === n && (e.__c.__P = t), e.__c = null), e.__k = e.__k && e.__k.map(function(o) {
    return bt(o, t, n);
  })), e;
}
function Pt(e, t, n) {
  return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function(o) {
    return Pt(o, t, n);
  }), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function ge() {
  this.__u = 0, this.t = null, this.__b = null;
}
function St(e) {
  var t = e.__.__c;
  return t && t.__a && t.__a(e);
}
function re() {
  this.u = null, this.o = null;
}
v.unmount = function(e) {
  var t = e.__c;
  t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Xe && Xe(e);
}, (ge.prototype = new T()).__c = function(e, t) {
  var n = t.__c, o = this;
  o.t == null && (o.t = []), o.t.push(n);
  var i = St(o.__v), r = !1, a = function() {
    r || (r = !0, n.__R = null, i ? i(s) : s());
  };
  n.__R = a;
  var s = function() {
    if (!--o.__u) {
      if (o.state.__a) {
        var u = o.state.__a;
        o.__v.__k[0] = Pt(u, u.__c.__P, u.__c.__O);
      }
      var c;
      for (o.setState({ __a: o.__b = null }); c = o.t.pop(); ) c.forceUpdate();
    }
  };
  o.__u++ || 32 & t.__u || o.setState({ __a: o.__b = o.__v.__k[0] }), e.then(a, a);
}, ge.prototype.componentWillUnmount = function() {
  this.t = [];
}, ge.prototype.render = function(e, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"), o = this.__v.__k[0].__c;
      this.__v.__k[0] = bt(this.__b, n, o.__O = o.__P);
    }
    this.__b = null;
  }
  var i = t.__a && j(S, null, e.fallback);
  return i && (i.__u &= -33), [j(S, null, t.__a ? null : e.children), i];
};
var Qe = function(e, t, n) {
  if (++n[1] === n[0] && e.o.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.o.size)) for (n = e.u; n; ) {
    for (; n.length > 3; ) n.pop()();
    if (n[1] < n[0]) break;
    e.u = n = n[2];
  }
};
function rn(e) {
  return this.getChildContext = function() {
    return e.context;
  }, e.children;
}
function an(e) {
  var t = this, n = e.i;
  t.componentWillUnmount = function() {
    Me(null, t.l), t.l = null, t.i = null;
  }, t.i && t.i !== n && t.componentWillUnmount(), t.l || (t.i = n, t.l = { nodeType: 1, parentNode: n, childNodes: [], appendChild: function(o) {
    this.childNodes.push(o), t.i.appendChild(o);
  }, insertBefore: function(o, i) {
    this.childNodes.push(o), t.i.appendChild(o);
  }, removeChild: function(o) {
    this.childNodes.splice(this.childNodes.indexOf(o) >>> 1, 1), t.i.removeChild(o);
  } }), Me(j(rn, { context: t.context }, e.__v), t.l);
}
function sn(e, t) {
  var n = j(an, { __v: e, i: t });
  return n.containerInfo = t, n;
}
(re.prototype = new T()).__a = function(e) {
  var t = this, n = St(t.__v), o = t.o.get(e);
  return o[0]++, function(i) {
    var r = function() {
      t.props.revealOrder ? (o.push(i), Qe(t, e, o)) : i();
    };
    n ? n(r) : r();
  };
}, re.prototype.render = function(e) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var t = _e(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
  for (var n = t.length; n--; ) this.o.set(t[n], this.u = [1, 0, this.u]);
  return e.children;
}, re.prototype.componentDidUpdate = re.prototype.componentDidMount = function() {
  var e = this;
  this.o.forEach(function(t, n) {
    Qe(e, n, t);
  });
};
var ln = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, un = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, cn = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, dn = /[A-Z0-9]/g, _n = typeof document < "u", vn = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
};
T.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(e) {
  Object.defineProperty(T.prototype, e, { configurable: !0, get: function() {
    return this["UNSAFE_" + e];
  }, set: function(t) {
    Object.defineProperty(this, e, { configurable: !0, writable: !0, value: t });
  } });
});
var et = v.event;
function hn() {
}
function pn() {
  return this.cancelBubble;
}
function fn() {
  return this.defaultPrevented;
}
v.event = function(e) {
  return et && (e = et(e)), e.persist = hn, e.isPropagationStopped = pn, e.isDefaultPrevented = fn, e.nativeEvent = e;
};
var mn = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, tt = v.vnode;
v.vnode = function(e) {
  typeof e.type == "string" && function(t) {
    var n = t.props, o = t.type, i = {};
    for (var r in n) {
      var a = n[r];
      if (!(r === "value" && "defaultValue" in n && a == null || _n && r === "children" && o === "noscript" || r === "class" || r === "className")) {
        var s = r.toLowerCase();
        r === "defaultValue" && "value" in n && n.value == null ? r = "value" : r === "download" && a === !0 ? a = "" : s === "ondoubleclick" ? r = "ondblclick" : s !== "onchange" || o !== "input" && o !== "textarea" || vn(n.type) ? s === "onfocus" ? r = "onfocusin" : s === "onblur" ? r = "onfocusout" : cn.test(r) ? r = s : o.indexOf("-") === -1 && un.test(r) ? r = r.replace(dn, "-$&").toLowerCase() : a === null && (a = void 0) : s = r = "oninput", s === "oninput" && i[r = s] && (r = "oninputCapture"), i[r] = a;
      }
    }
    o == "select" && i.multiple && Array.isArray(i.value) && (i.value = _e(n.children).forEach(function(u) {
      u.props.selected = i.value.indexOf(u.props.value) != -1;
    })), o == "select" && i.defaultValue != null && (i.value = _e(n.children).forEach(function(u) {
      u.props.selected = i.multiple ? i.defaultValue.indexOf(u.props.value) != -1 : i.defaultValue == u.props.value;
    })), n.class && !n.className ? (i.class = n.class, Object.defineProperty(i, "className", mn)) : (n.className && !n.class || n.class && n.className) && (i.class = i.className = n.className), t.props = i;
  }(e), e.$$typeof = ln, tt && tt(e);
};
var nt = v.__r;
v.__r = function(e) {
  nt && nt(e), e.__c;
};
var ot = v.diffed;
v.diffed = function(e) {
  ot && ot(e);
  var t = e.props, n = e.__e;
  n != null && e.type === "textarea" && "value" in t && t.value !== n.value && (n.value = t.value == null ? "" : t.value);
};
function ye() {
  throw new Error("Cycle detected");
}
var yn = Symbol.for("preact-signals");
function $e() {
  if (R > 1)
    R--;
  else {
    for (var e, t = !1; Z !== void 0; ) {
      var n = Z;
      for (Z = void 0, xe++; n !== void 0; ) {
        var o = n.o;
        if (n.o = void 0, n.f &= -3, !(8 & n.f) && Mt(n)) try {
          n.c();
        } catch (i) {
          t || (e = i, t = !0);
        }
        n = o;
      }
    }
    if (xe = 0, R--, t) throw e;
  }
}
var k = void 0, Z = void 0, R = 0, xe = 0, ve = 0;
function wt(e) {
  if (k !== void 0) {
    var t = e.n;
    if (t === void 0 || t.t !== k)
      return t = { i: 0, S: e, p: k.s, n: void 0, t: k, e: void 0, x: void 0, r: t }, k.s !== void 0 && (k.s.n = t), k.s = t, e.n = t, 32 & k.f && e.S(t), t;
    if (t.i === -1)
      return t.i = 0, t.n !== void 0 && (t.n.p = t.p, t.p !== void 0 && (t.p.n = t.n), t.p = k.s, t.n = void 0, k.s.n = t, k.s = t), t;
  }
}
function P(e) {
  this.v = e, this.i = 0, this.n = void 0, this.t = void 0;
}
P.prototype.brand = yn;
P.prototype.h = function() {
  return !0;
};
P.prototype.S = function(e) {
  this.t !== e && e.e === void 0 && (e.x = this.t, this.t !== void 0 && (this.t.e = e), this.t = e);
};
P.prototype.U = function(e) {
  if (this.t !== void 0) {
    var t = e.e, n = e.x;
    t !== void 0 && (t.x = n, e.e = void 0), n !== void 0 && (n.e = t, e.x = void 0), e === this.t && (this.t = n);
  }
};
P.prototype.subscribe = function(e) {
  var t = this;
  return X(function() {
    var n = t.value, o = 32 & this.f;
    this.f &= -33;
    try {
      e(n);
    } finally {
      this.f |= o;
    }
  });
};
P.prototype.valueOf = function() {
  return this.value;
};
P.prototype.toString = function() {
  return this.value + "";
};
P.prototype.toJSON = function() {
  return this.value;
};
P.prototype.peek = function() {
  return this.v;
};
Object.defineProperty(P.prototype, "value", { get: function() {
  var e = wt(this);
  return e !== void 0 && (e.i = this.i), this.v;
}, set: function(e) {
  if (k instanceof W && function() {
    throw new Error("Computed cannot have side-effects");
  }(), e !== this.v) {
    xe > 100 && ye(), this.v = e, this.i++, ve++, R++;
    try {
      for (var t = this.t; t !== void 0; t = t.x) t.t.N();
    } finally {
      $e();
    }
  }
} });
function w(e) {
  return new P(e);
}
function Mt(e) {
  for (var t = e.s; t !== void 0; t = t.n) if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
  return !1;
}
function Yt(e) {
  for (var t = e.s; t !== void 0; t = t.n) {
    var n = t.S.n;
    if (n !== void 0 && (t.r = n), t.S.n = t, t.i = -1, t.n === void 0) {
      e.s = t;
      break;
    }
  }
}
function Nt(e) {
  for (var t = e.s, n = void 0; t !== void 0; ) {
    var o = t.p;
    t.i === -1 ? (t.S.U(t), o !== void 0 && (o.n = t.n), t.n !== void 0 && (t.n.p = o)) : n = t, t.S.n = t.r, t.r !== void 0 && (t.r = void 0), t = o;
  }
  e.s = n;
}
function W(e) {
  P.call(this, void 0), this.x = e, this.s = void 0, this.g = ve - 1, this.f = 4;
}
(W.prototype = new P()).h = function() {
  if (this.f &= -3, 1 & this.f) return !1;
  if ((36 & this.f) == 32 || (this.f &= -5, this.g === ve)) return !0;
  if (this.g = ve, this.f |= 1, this.i > 0 && !Mt(this))
    return this.f &= -2, !0;
  var e = k;
  try {
    Yt(this), k = this;
    var t = this.x();
    (16 & this.f || this.v !== t || this.i === 0) && (this.v = t, this.f &= -17, this.i++);
  } catch (n) {
    this.v = n, this.f |= 16, this.i++;
  }
  return k = e, Nt(this), this.f &= -2, !0;
};
W.prototype.S = function(e) {
  if (this.t === void 0) {
    this.f |= 36;
    for (var t = this.s; t !== void 0; t = t.n) t.S.S(t);
  }
  P.prototype.S.call(this, e);
};
W.prototype.U = function(e) {
  if (this.t !== void 0 && (P.prototype.U.call(this, e), this.t === void 0)) {
    this.f &= -33;
    for (var t = this.s; t !== void 0; t = t.n) t.S.U(t);
  }
};
W.prototype.N = function() {
  if (!(2 & this.f)) {
    this.f |= 6;
    for (var e = this.t; e !== void 0; e = e.x) e.t.N();
  }
};
W.prototype.peek = function() {
  if (this.h() || ye(), 16 & this.f) throw this.v;
  return this.v;
};
Object.defineProperty(W.prototype, "value", { get: function() {
  1 & this.f && ye();
  var e = wt(this);
  if (this.h(), e !== void 0 && (e.i = this.i), 16 & this.f) throw this.v;
  return this.v;
} });
function Dn(e) {
  return new W(e);
}
function xt(e) {
  var t = e.u;
  if (e.u = void 0, typeof t == "function") {
    R++;
    var n = k;
    k = void 0;
    try {
      t();
    } catch (o) {
      throw e.f &= -2, e.f |= 8, Ae(e), o;
    } finally {
      k = n, $e();
    }
  }
}
function Ae(e) {
  for (var t = e.s; t !== void 0; t = t.n) t.S.U(t);
  e.x = void 0, e.s = void 0, xt(e);
}
function kn(e) {
  if (k !== this) throw new Error("Out-of-order effect");
  Nt(this), k = e, this.f &= -2, 8 & this.f && Ae(this), $e();
}
function Q(e) {
  this.x = e, this.u = void 0, this.s = void 0, this.o = void 0, this.f = 32;
}
Q.prototype.c = function() {
  var e = this.S();
  try {
    if (8 & this.f || this.x === void 0) return;
    var t = this.x();
    typeof t == "function" && (this.u = t);
  } finally {
    e();
  }
};
Q.prototype.S = function() {
  1 & this.f && ye(), this.f |= 1, this.f &= -9, xt(this), Yt(this), R++;
  var e = k;
  return k = this, kn.bind(this, e);
};
Q.prototype.N = function() {
  2 & this.f || (this.f |= 2, this.o = Z, Z = this);
};
Q.prototype.d = function() {
  this.f |= 8, 1 & this.f || Ae(this);
};
function X(e) {
  var t = new Q(e);
  try {
    t.c();
  } catch (n) {
    throw t.d(), n;
  }
  return t.d.bind(t);
}
var be;
function B(e, t) {
  v[e] = t.bind(null, v[e] || function() {
  });
}
function he(e) {
  be && be(), be = e && e.S();
}
function Et(e) {
  var t = this, n = e.data, o = bn(n);
  o.value = n;
  var i = Dt(function() {
    for (var r = t.__v; r = r.__; ) if (r.__c) {
      r.__c.__$f |= 4;
      break;
    }
    return t.__$u.c = function() {
      var a;
      !ut(i.peek()) && ((a = t.base) == null ? void 0 : a.nodeType) === 3 ? t.base.data = i.peek() : (t.__$f |= 1, t.setState({}));
    }, Dn(function() {
      var a = o.value.value;
      return a === 0 ? 0 : a === !0 ? "" : a || "";
    });
  }, []);
  return i.value;
}
Et.displayName = "_st";
Object.defineProperties(P.prototype, { constructor: { configurable: !0, value: void 0 }, type: { configurable: !0, value: Et }, props: { configurable: !0, get: function() {
  return { data: this };
} }, __b: { configurable: !0, value: 1 } });
B("__b", function(e, t) {
  if (typeof t.type == "string") {
    var n, o = t.props;
    for (var i in o) if (i !== "children") {
      var r = o[i];
      r instanceof P && (n || (t.__np = n = {}), n[i] = r, o[i] = r.peek());
    }
  }
  e(t);
});
B("__r", function(e, t) {
  he();
  var n, o = t.__c;
  o && (o.__$f &= -2, (n = o.__$u) === void 0 && (o.__$u = n = function(i) {
    var r;
    return X(function() {
      r = this;
    }), r.c = function() {
      o.__$f |= 1, o.setState({});
    }, r;
  }())), he(n), e(t);
});
B("__e", function(e, t, n, o) {
  he(), e(t, n, o);
});
B("diffed", function(e, t) {
  he();
  var n;
  if (typeof t.type == "string" && (n = t.__e)) {
    var o = t.__np, i = t.props;
    if (o) {
      var r = n.U;
      if (r) for (var a in r) {
        var s = r[a];
        s !== void 0 && !(a in o) && (s.d(), r[a] = void 0);
      }
      else n.U = r = {};
      for (var u in o) {
        var c = r[u], d = o[u];
        c === void 0 ? (c = gn(n, u, d, i), r[u] = c) : c.o(d, i);
      }
    }
  }
  e(t);
});
function gn(e, t, n, o) {
  var i = t in e && e.ownerSVGElement === void 0, r = w(n);
  return { o: function(a, s) {
    r.value = a, o = s;
  }, d: X(function() {
    var a = r.value.value;
    o[t] !== a && (o[t] = a, i ? e[t] = a : a ? e.setAttribute(t, a) : e.removeAttribute(t));
  }) };
}
B("unmount", function(e, t) {
  if (typeof t.type == "string") {
    var n = t.__e;
    if (n) {
      var o = n.U;
      if (o) {
        n.U = void 0;
        for (var i in o) {
          var r = o[i];
          r && r.d();
        }
      }
    }
  } else {
    var a = t.__c;
    if (a) {
      var s = a.__$u;
      s && (a.__$u = void 0, s.d());
    }
  }
  e(t);
});
B("__h", function(e, t, n, o) {
  (o < 3 || o === 9) && (t.__$f |= 2), e(t, n, o);
});
T.prototype.shouldComponentUpdate = function(e, t) {
  var n = this.__$u;
  if (!(n && n.s !== void 0 || 4 & this.__$f) || 3 & this.__$f) return !0;
  for (var o in t) return !0;
  for (var i in e) if (i !== "__source" && e[i] !== this.props[i]) return !0;
  for (var r in this.props) if (!(r in e)) return !0;
  return !1;
};
function bn(e) {
  return Dt(function() {
    return w(e);
  }, []);
}
const O = qt({}), it = {
  DATE_STRING: /^\d{4}-\d{2}-\d{2}$/,
  TIME_STRING: /^\d{2}:\d{2}$/,
  DATE_TIME_STRING: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/
};
class Pn extends Error {
  constructor(t) {
    super(`Invalid date time specification: ${t}`);
  }
}
const I = (e) => {
  if (!it.DATE_TIME_STRING.test(e) && !it.DATE_STRING.test(e))
    throw new Pn(e);
  return new Date(
    Number(e.slice(0, 4)),
    Number(e.slice(5, 7)) - 1,
    Number(e.slice(8, 10)),
    Number(e.slice(11, 13)),
    // for date strings this will be 0
    Number(e.slice(14, 16))
    // for date strings this will be 0
  );
}, ee = (e) => {
  const t = e.slice(11, 13), n = e.slice(14, 16);
  return {
    year: Number(e.slice(0, 4)),
    month: Number(e.slice(5, 7)) - 1,
    date: Number(e.slice(8, 10)),
    hours: t !== "" ? Number(t) : void 0,
    minutes: n !== "" ? Number(n) : void 0
  };
}, Lt = (e, t) => e.toLocaleString(t, { month: "long" }), Sn = (e, t) => e.toLocaleString(t, {
  month: "numeric",
  day: "numeric",
  year: "numeric"
}), wn = (e, t) => e.map((n) => n.toLocaleString(t, { weekday: "short" }).charAt(0)), Mn = (e, t) => e.toLocaleString(t, { weekday: "short" }), Yn = (e, t) => e.map((n) => Mn(n, t)), Nn = (e, t) => ["zh-cn", "zh-tw", "ca-es"].includes(t.toLowerCase()) ? Yn(e, t) : wn(e, t);
var xn = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Uploaded to: SVG Repo%2c www.svgrepo.com%2c Generator: SVG Repo Mixer Tools --%3e%3csvg width='800px' height='800px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6 9L12 15L18 9' stroke='%23DED8E1' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";
const ce = () => "s" + Math.random().toString(36).substring(2, 11), Tt = (e) => e.key === "Enter" || e.key === " ";
function En() {
  const e = ce(), t = ce(), n = ce(), o = F(O), i = (_) => _ === "" ? o.translate("MM/DD/YYYY") : Sn(I(_), o.config.locale.value);
  L(() => {
    o.datePickerState.inputDisplayedValue.value = i(o.datePickerState.selectedDate.value);
  }, [o.datePickerState.selectedDate.value, o.config.locale.value]);
  const [r, a] = C([]), s = () => {
    const _ = document.getElementById(n);
    o.datePickerState.inputWrapperElement.value = _ instanceof HTMLDivElement ? _ : void 0;
  };
  L(() => {
    o.config.teleportTo && s();
    const _ = ["sx__date-input-wrapper"];
    o.datePickerState.isOpen.value && _.push("sx__date-input--active"), a(_);
  }, [o.datePickerState.isOpen.value]);
  const u = (_) => {
    _.key === "Enter" && c(_);
  }, c = (_) => {
    _.stopPropagation();
    try {
      o.datePickerState.inputDisplayedValue.value = _.target.value, o.datePickerState.close();
    } catch {
    }
  };
  L(() => {
    const _ = document.getElementById(e);
    if (_ !== null)
      return _.addEventListener("change", c), () => _.removeEventListener("change", c);
  });
  const d = (_) => {
    c(_), o.datePickerState.open();
  }, l = (_) => {
    Tt(_) && (_.preventDefault(), o.datePickerState.open(), setTimeout(() => {
      const h = document.querySelector('[data-focus="true"]');
      h instanceof HTMLElement && h.focus();
    }, 50));
  };
  return p(S, { children: p("div", { className: r.join(" "), id: n, children: [p("label", { for: e, id: t, className: "sx__date-input-label", children: o.config.label || o.translate("Date") }), p("input", { id: e, tabIndex: o.datePickerState.isDisabled.value ? -1 : 0, name: o.config.name || "date", "aria-describedby": t, value: o.datePickerState.inputDisplayedValue.value, "data-testid": "date-picker-input", className: "sx__date-input", onClick: d, onKeyUp: u, type: "text" }), p("button", { tabIndex: o.datePickerState.isDisabled.value ? -1 : 0, "aria-label": o.translate("Choose Date"), onKeyDown: l, onClick: () => o.datePickerState.open(), className: "sx__date-input-chevron-wrapper", children: p("img", { className: "sx__date-input-chevron", src: xn, alt: "" }) })] }) });
}
var V;
(function(e) {
  e.MONTH_DAYS = "month-days", e.YEARS = "years";
})(V || (V = {}));
const Ln = "years-view", Tn = "months-view", Cn = "date-picker-week";
class On extends Error {
  constructor(t, n) {
    super(`Number must be between ${t} and ${n}.`), Object.defineProperty(this, "min", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "max", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    });
  }
}
const M = (e) => {
  if (e < 0 || e > 99)
    throw new On(0, 99);
  return String(e).padStart(2, "0");
}, E = (e) => `${e.getFullYear()}-${M(e.getMonth() + 1)}-${M(e.getDate())}`, $n = (e) => `${M(e.getHours())}:${M(e.getMinutes())}`, Ct = (e) => `${E(e)} ${$n(e)}`, Ot = (e, t) => {
  const { year: n, month: o, date: i, hours: r, minutes: a } = ee(e), s = r !== void 0 && a !== void 0, u = new Date(n, o, i, r ?? 0, a ?? 0);
  let c = (u.getMonth() + t) % 12;
  return c < 0 && (c += 12), u.setMonth(u.getMonth() + t), u.getMonth() > c ? u.setDate(0) : u.getMonth() < c && (u.setMonth(u.getMonth() + 1), u.setDate(0)), s ? Ct(u) : E(u);
}, An = (e, t) => {
  const { year: n, month: o, date: i, hours: r, minutes: a } = ee(e), s = r !== void 0 && a !== void 0, u = new Date(n, o, i, r ?? 0, a ?? 0);
  return u.setDate(u.getDate() + t), s ? Ct(u) : E(u);
}, $t = (e, t) => (e = e.slice(0, 8) + M(t) + e.slice(10), e), Fn = (e) => (e = Ot(e, -1), $t(e, 1)), Wn = (e) => (e = Ot(e, 1), $t(e, 1));
function rt({ direction: e, onClick: t, buttonText: n, disabled: o = !1 }) {
  return p("button", { disabled: o, className: "sx__chevron-wrapper sx__ripple", onMouseUp: t, onKeyDown: (r) => {
    Tt(r) && t();
  }, tabIndex: 0, children: p("i", { className: `sx__chevron sx__chevron--${e}`, children: n }) });
}
function Un({ setYearsView: e }) {
  const t = F(O), n = (l) => {
    const _ = I(l);
    return Lt(_, t.config.locale.value);
  }, o = (l) => ee(l).year, [i, r] = C(n(t.datePickerState.datePickerDate.value)), [a, s] = C(o(t.datePickerState.datePickerDate.value)), u = () => {
    t.datePickerState.datePickerDate.value = Fn(t.datePickerState.datePickerDate.value);
  }, c = () => {
    t.datePickerState.datePickerDate.value = Wn(t.datePickerState.datePickerDate.value);
  };
  L(() => {
    r(n(t.datePickerState.datePickerDate.value)), s(o(t.datePickerState.datePickerDate.value));
  }, [t.datePickerState.datePickerDate.value]);
  const d = (l) => {
    l.stopPropagation(), e();
  };
  return p(S, { children: p("header", { className: "sx__date-picker__month-view-header", children: [p(rt, { direction: "previous", onClick: () => u(), buttonText: t.translate("Previous month") }), p("button", { className: "sx__date-picker__month-view-header__month-year", onClick: (l) => d(l), children: i + " " + a }), p(rt, { direction: "next", onClick: () => c(), buttonText: t.translate("Next month") })] }) });
}
function Vn() {
  const e = F(O), t = e.timeUnitsImpl.getWeekFor(I(e.datePickerState.datePickerDate.value)), n = Nn(t, e.config.locale.value);
  return p("div", { className: "sx__date-picker__day-names", children: n.map((o) => p("span", { "data-testid": "day-name", className: "sx__date-picker__day-name", children: o })) });
}
const In = (e) => {
  const t = /* @__PURE__ */ new Date();
  return e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
}, Rn = (e, t) => e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
var Ee;
(function(e) {
  e[e.SUNDAY = 0] = "SUNDAY", e[e.MONDAY = 1] = "MONDAY", e[e.TUESDAY = 2] = "TUESDAY", e[e.WEDNESDAY = 3] = "WEDNESDAY", e[e.THURSDAY = 4] = "THURSDAY", e[e.FRIDAY = 5] = "FRIDAY", e[e.SATURDAY = 6] = "SATURDAY";
})(Ee || (Ee = {}));
const jn = "en-US", Hn = Ee.MONDAY, zn = (e, t) => {
  const { year: n, month: o, date: i } = ee(e);
  return new Date(n, o, i).toLocaleDateString(t, {
    day: "numeric",
    month: "long",
    year: "numeric"
  });
}, Bn = zn;
function Kn({ week: e }) {
  const t = F(O), n = e.map((s) => {
    const u = ["sx__date-picker__day"];
    return In(s) && u.push("sx__date-picker__day--today"), E(s) === t.datePickerState.selectedDate.value && u.push("sx__date-picker__day--selected"), Rn(s, I(t.datePickerState.datePickerDate.value)) || u.push("is-leading-or-trailing"), {
      day: s,
      classes: u
    };
  }), o = (s) => {
    const u = E(s);
    return u >= t.config.min && u <= t.config.max;
  }, i = (s) => {
    t.datePickerState.selectedDate.value = E(s), t.datePickerState.close();
  }, r = (s) => E(s.day) === t.datePickerState.datePickerDate.value, a = (s) => {
    if (s.key === "Enter") {
      t.datePickerState.selectedDate.value = t.datePickerState.datePickerDate.value, t.datePickerState.close();
      return;
    }
    const u = /* @__PURE__ */ new Map([
      ["ArrowDown", 7],
      ["ArrowUp", -7],
      ["ArrowLeft", -1],
      ["ArrowRight", 1]
    ]);
    t.datePickerState.datePickerDate.value = An(t.datePickerState.datePickerDate.value, u.get(s.key) || 0);
  };
  return p(S, { children: p("div", { "data-testid": Cn, className: "sx__date-picker__week", children: n.map((s) => p("button", { tabIndex: r(s) ? 0 : -1, disabled: !o(s.day), "aria-label": Bn(t.datePickerState.datePickerDate.value, t.config.locale.value), className: s.classes.join(" "), "data-focus": r(s) ? "true" : void 0, onClick: () => i(s.day), onKeyDown: a, children: s.day.getDate() })) }) });
}
function Gn({ seatYearsView: e }) {
  const t = ce(), n = F(O), [o, i] = C([]), r = () => {
    const a = I(n.datePickerState.datePickerDate.value);
    i(n.timeUnitsImpl.getMonthWithTrailingAndLeadingDays(a.getFullYear(), a.getMonth()));
  };
  return L(() => {
    r();
  }, [n.datePickerState.datePickerDate.value]), L(() => {
    const a = new MutationObserver((u) => {
      u.forEach((c) => {
        const d = c.target;
        d.dataset.focus === "true" && d.focus();
      });
    }), s = document.getElementById(t);
    return a.observe(s, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => a.disconnect();
  }, []), p(S, { children: p("div", { id: t, "data-testid": Tn, className: "sx__date-picker__month-view", children: [p(Un, { setYearsView: e }), p(Vn, {}), o.map((a) => p(Kn, { week: a }))] }) });
}
function Jn({ year: e, setYearAndMonth: t, isExpanded: n, expand: o }) {
  const i = F(O), r = i.timeUnitsImpl.getMonthsFor(e), a = (s, u) => {
    s.stopPropagation(), t(e, u.getMonth());
  };
  return p(S, { children: p("li", { className: n ? "sx__is-expanded" : "", children: [p("button", { className: "sx__date-picker__years-accordion__expand-button sx__ripple--wide", onClick: () => o(e), children: e }), n && p("div", { className: "sx__date-picker__years-view-accordion__panel", children: r.map((s) => p("button", { className: "sx__date-picker__years-view-accordion__month", onClick: (u) => a(u, s), children: Lt(s, i.config.locale.value) })) })] }) });
}
function Zn({ setMonthView: e }) {
  const t = F(O), n = I(t.config.min).getFullYear(), o = I(t.config.max).getFullYear(), i = Array.from({ length: o - n + 1 }, (c, d) => n + d), { year: r } = ee(t.datePickerState.selectedDate.value), [a, s] = C(r), u = (c, d) => {
    t.datePickerState.datePickerDate.value = E(new Date(c, d, 1)), e();
  };
  return L(() => {
    var c;
    const d = (c = document.querySelector(".sx__date-picker__years-view")) === null || c === void 0 ? void 0 : c.querySelector(".sx__is-expanded");
    d && d.scrollIntoView({
      block: "center"
    });
  }, []), p(S, { children: p("ul", { className: "sx__date-picker__years-view", "data-testid": Ln, children: i.map((c) => p(Jn, { year: c, setYearAndMonth: (d, l) => u(d, l), isExpanded: a === c, expand: (d) => s(d) })) }) });
}
const qn = (e) => {
  if (e) {
    const t = e.scrollHeight > e.clientHeight, o = window.getComputedStyle(e).overflowY.indexOf("hidden") !== -1;
    return t && !o;
  }
  return !0;
}, At = (e, t = []) => !e || e === document.body || e.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (t.push(window), t) : (qn(e) && t.push(e), At(e.assignedSlot ? e.assignedSlot.parentNode : e.parentNode, t)), at = "sx__date-picker-popup";
function Xn() {
  const e = F(O), [t, n] = C(V.MONTH_DAYS), o = [at, e.config.placement], [i, r] = C(o);
  L(() => {
    r([
      ...o,
      e.datePickerState.isDark.value ? "is-dark" : "",
      e.config.teleportTo ? "is-teleported" : ""
    ]);
  }, [e.datePickerState.isDark.value]);
  const a = (m) => {
    m.target.closest(`.${at}`) || e.datePickerState.close();
  }, s = (m) => {
    m.key === "Escape" && (e.config.listeners.onEscapeKeyDown ? e.config.listeners.onEscapeKeyDown(e) : e.datePickerState.close());
  };
  L(() => (document.addEventListener("click", a), document.addEventListener("keydown", s), () => {
    document.removeEventListener("click", a), document.removeEventListener("keydown", s);
  }), []);
  const u = Number(getComputedStyle(document.documentElement).fontSize.split("px")[0]), c = 362, d = 332, l = () => {
    const m = e.datePickerState.inputWrapperElement.value, f = m == null ? void 0 : m.getBoundingClientRect();
    if (!(m === void 0 || !(f instanceof DOMRect)))
      return {
        top: e.config.placement.includes("bottom") ? f.height + f.y + 1 : f.y - u - c,
        // subtract remsize to leave room for label text
        left: e.config.placement.includes("start") ? f.x : f.x + f.width - d,
        width: d,
        position: "fixed"
      };
  }, [_, h] = C(l());
  return L(() => {
    const m = e.datePickerState.inputWrapperElement.value;
    if (m === void 0)
      return;
    const f = At(m), g = () => h(l());
    return f.forEach((y) => y.addEventListener("scroll", g)), () => f.forEach((y) => y.removeEventListener("scroll", g));
  }, []), p(S, { children: p("div", { style: e.config.teleportTo ? _ : void 0, "data-testid": "date-picker-popup", className: i.join(" "), children: t === V.MONTH_DAYS ? p(Gn, { seatYearsView: () => n(V.YEARS) }) : p(Zn, { setMonthView: () => n(V.MONTH_DAYS) }) }) });
}
function Qn({ $app: e }) {
  const t = ["sx__date-picker-wrapper"], [n, o] = C(t);
  L(() => {
    var r;
    const a = [...t];
    e.datePickerState.isDark.value && a.push("is-dark"), !((r = e.config.style) === null || r === void 0) && r.fullWidth && a.push("has-full-width"), e.datePickerState.isDisabled.value && a.push("is-disabled"), o(a);
  }, [e.datePickerState.isDark.value, e.datePickerState.isDisabled.value]);
  let i = p(Xn, {});
  return e.config.teleportTo && (i = sn(i, e.config.teleportTo)), p(S, { children: p("div", { className: n.join(" "), children: p(O.Provider, { value: e, children: [p(En, {}), e.datePickerState.isOpen.value && i] }) }) });
}
class eo {
  constructor(t) {
    Object.defineProperty(this, "$app", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    });
  }
  render(t) {
    Me(j(Qn, {
      $app: this.$app
    }), t);
  }
  get value() {
    return this.$app.datePickerState.selectedDate.value;
  }
  set value(t) {
    this.$app.datePickerState.selectedDate.value = t;
  }
  get disabled() {
    return this.$app.datePickerState.isDisabled.value;
  }
  set disabled(t) {
    this.$app.datePickerState.isDisabled.value = t;
  }
  setTheme(t) {
    this.$app.datePickerState.isDark.value = t === "dark";
  }
  getTheme() {
    return this.$app.datePickerState.isDark.value ? "dark" : "light";
  }
}
var Le;
(function(e) {
  e[e.JANUARY = 0] = "JANUARY", e[e.FEBRUARY = 1] = "FEBRUARY", e[e.MARCH = 2] = "MARCH", e[e.APRIL = 3] = "APRIL", e[e.MAY = 4] = "MAY", e[e.JUNE = 5] = "JUNE", e[e.JULY = 6] = "JULY", e[e.AUGUST = 7] = "AUGUST", e[e.SEPTEMBER = 8] = "SEPTEMBER", e[e.OCTOBER = 9] = "OCTOBER", e[e.NOVEMBER = 10] = "NOVEMBER", e[e.DECEMBER = 11] = "DECEMBER";
})(Le || (Le = {}));
class Ft extends Error {
  constructor() {
    super("Year zero does not exist in the Gregorian calendar.");
  }
}
class to extends Date {
  constructor(t, n, o) {
    if (super(t, n, o), t === 0)
      throw new Ft();
    this.setFullYear(t);
  }
  get year() {
    return this.getFullYear();
  }
  get month() {
    return this.getMonth();
  }
  get date() {
    return this.getDate();
  }
}
class no {
  constructor(t) {
    Object.defineProperty(this, "config", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    });
  }
  get firstDayOfWeek() {
    return this.config.firstDayOfWeek.value;
  }
  set firstDayOfWeek(t) {
    this.config.firstDayOfWeek.value = t;
  }
  getMonthWithTrailingAndLeadingDays(t, n) {
    if (t === 0)
      throw new Ft();
    const o = new Date(t, n, 1), i = [this.getWeekFor(o)];
    let r = !0, a = i[0][0];
    for (; r; ) {
      const s = new Date(a.getFullYear(), a.getMonth(), a.getDate() + 7);
      s.getMonth() === n ? (i.push(this.getWeekFor(s)), a = s) : r = !1;
    }
    return i;
  }
  getWeekFor(t) {
    const n = [this.getFirstDateOfWeek(t)];
    for (; n.length < 7; ) {
      const o = n[n.length - 1], i = new Date(o);
      i.setDate(o.getDate() + 1), n.push(i);
    }
    return n;
  }
  getMonthsFor(t) {
    return Object.values(Le).filter((n) => !isNaN(Number(n))).map((n) => new to(t, Number(n), 1));
  }
  getFirstDateOfWeek(t) {
    const n = t.getDay() - this.firstDayOfWeek, o = t;
    return n === 0 || (n > 0 ? o.setDate(t.getDate() - n) : o.setDate(t.getDate() - (7 + n))), o;
  }
}
class oo {
  constructor() {
    Object.defineProperty(this, "config", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
  }
  build() {
    return new no(this.config);
  }
  withConfig(t) {
    return this.config = t, this;
  }
}
var N;
(function(e) {
  e.SLASH = "/", e.DASH = "-", e.PERIOD = ".";
})(N || (N = {}));
var x;
(function(e) {
  e.DMY = "DMY", e.MDY = "MDY", e.YMD = "YMD";
})(x || (x = {}));
const G = {
  slashMDY: {
    delimiter: N.SLASH,
    order: x.MDY
  },
  slashDMY: {
    delimiter: N.SLASH,
    order: x.DMY
  },
  slashYMD: {
    delimiter: N.SLASH,
    order: x.YMD
  },
  periodDMY: {
    delimiter: N.PERIOD,
    order: x.DMY
  },
  dashYMD: {
    delimiter: N.DASH,
    order: x.YMD
  }
}, io = /* @__PURE__ */ new Map([
  ["en-US", G.slashMDY],
  ["en-GB", G.slashDMY],
  ["zh-CN", G.slashYMD],
  ["de-DE", G.periodDMY],
  ["sv-SE", G.dashYMD]
]);
class ro extends Error {
  constructor(t) {
    super(`Locale not supported: ${t}`);
  }
}
class Wt extends Error {
  constructor(t, n) {
    super(`Invalid date format: ${t} for locale: ${n}`);
  }
}
const ae = (e, t, n) => {
  const o = e.match(t);
  if (!o)
    throw new Wt(e, n);
  return o;
}, ao = (e, t) => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(e))
    return e;
  const o = io.get(t);
  if (!o)
    throw new ro(t);
  const { order: i, delimiter: r } = o, a = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/, s = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/, u = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
  if (i === x.DMY && r === N.SLASH) {
    const c = ae(e, a, t), [, d, l, _] = c;
    return `${_}-${M(+l)}-${M(+d)}`;
  }
  if (i === x.MDY && r === N.SLASH) {
    const c = ae(e, a, t), [, d, l, _] = c;
    return `${_}-${M(+d)}-${M(+l)}`;
  }
  if (i === x.YMD && r === N.SLASH) {
    const c = ae(e, u, t), [, d, l, _] = c;
    return `${d}-${M(+l)}-${M(+_)}`;
  }
  if (i === x.DMY && r === N.PERIOD) {
    const c = ae(e, s, t), [, d, l, _] = c;
    return `${_}-${M(+l)}-${M(+d)}`;
  }
  throw new Wt(e, t);
}, so = (e, t) => {
  var n;
  const o = E(/* @__PURE__ */ new Date()), i = typeof t == "string" ? t : o, r = w(!1), a = w(e.disabled || !1), s = w(V.MONTH_DAYS), u = w(i), c = w(i || o), d = w(((n = e.style) === null || n === void 0 ? void 0 : n.dark) || !1), l = w(t || ""), _ = w(t || "");
  X(() => {
    try {
      const f = ao(l.value, e.locale.value);
      if (f < e.min || f > e.max) {
        l.value = _.value;
        return;
      }
      u.value = f, c.value = f, _.value = l.value;
    } catch {
    }
  });
  let h = !1;
  const m = (f) => {
    if (!h)
      return h = !0;
    e.listeners.onChange(f);
  };
  return X(() => {
    var f;
    !((f = e.listeners) === null || f === void 0) && f.onChange && m(u.value);
  }), {
    inputWrapperElement: w(void 0),
    isOpen: r,
    isDisabled: a,
    datePickerView: s,
    selectedDate: u,
    datePickerDate: c,
    inputDisplayedValue: l,
    isDark: d,
    open: () => r.value = !0,
    close: () => r.value = !1,
    toggle: () => r.value = !r.value,
    setView: (f) => s.value = f
  };
};
class lo {
  constructor(t, n, o, i) {
    Object.defineProperty(this, "datePickerState", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "config", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }), Object.defineProperty(this, "timeUnitsImpl", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: o
    }), Object.defineProperty(this, "translate", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: i
    });
  }
}
class uo {
  constructor() {
    Object.defineProperty(this, "datePickerState", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "config", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "timeUnitsImpl", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "translate", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
  }
  build() {
    return new lo(this.datePickerState, this.config, this.timeUnitsImpl, this.translate);
  }
  withDatePickerState(t) {
    return this.datePickerState = t, this;
  }
  withConfig(t) {
    return this.config = t, this;
  }
  withTimeUnitsImpl(t) {
    return this.timeUnitsImpl = t, this;
  }
  withTranslate(t) {
    return this.translate = t, this;
  }
}
var Te;
(function(e) {
  e.TOP_START = "top-start", e.TOP_END = "top-end", e.BOTTOM_START = "bottom-start", e.BOTTOM_END = "bottom-end";
})(Te || (Te = {}));
class co {
  constructor(t = jn, n = Hn, o = E(new Date(1970, 0, 1)), i = E(new Date((/* @__PURE__ */ new Date()).getFullYear() + 50, 11, 31)), r = Te.BOTTOM_START, a = {}, s = {}, u, c, d, l) {
    Object.defineProperty(this, "min", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: o
    }), Object.defineProperty(this, "max", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: i
    }), Object.defineProperty(this, "placement", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }), Object.defineProperty(this, "listeners", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: a
    }), Object.defineProperty(this, "style", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: s
    }), Object.defineProperty(this, "teleportTo", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: u
    }), Object.defineProperty(this, "label", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: c
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: d
    }), Object.defineProperty(this, "disabled", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: l
    }), Object.defineProperty(this, "locale", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "firstDayOfWeek", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.locale = w(t), this.firstDayOfWeek = w(n);
  }
}
class _o {
  constructor() {
    Object.defineProperty(this, "locale", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "firstDayOfWeek", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "min", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "max", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "placement", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "listeners", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "style", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "teleportTo", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "label", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "disabled", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
  }
  build() {
    return new co(this.locale, this.firstDayOfWeek, this.min, this.max, this.placement, this.listeners, this.style, this.teleportTo, this.label, this.name, this.disabled);
  }
  withLocale(t) {
    return this.locale = t, this;
  }
  withFirstDayOfWeek(t) {
    return this.firstDayOfWeek = t, this;
  }
  withMin(t) {
    return this.min = t, this;
  }
  withMax(t) {
    return this.max = t, this;
  }
  withPlacement(t) {
    return this.placement = t, this;
  }
  withListeners(t) {
    return this.listeners = t, this;
  }
  withStyle(t) {
    return this.style = t, this;
  }
  withTeleportTo(t) {
    return this.teleportTo = t, this;
  }
  withLabel(t) {
    return this.label = t, this;
  }
  withName(t) {
    return this.name = t, this;
  }
  withDisabled(t) {
    return this.disabled = t, this;
  }
}
const vo = {
  Date: "Datum",
  "MM/DD/YYYY": "TT.MM.JJJJ",
  "Next month": "Nächster Monat",
  "Previous month": "Vorheriger Monat",
  "Choose Date": "Datum auswählen"
}, ho = {
  Today: "Heute",
  Month: "Monat",
  Week: "Woche",
  Day: "Tag",
  "Select View": "Ansicht auswählen",
  events: "Ereignisse",
  event: "Ereignis",
  "No events": "Keine Ereignisse",
  "Next period": "Nächster Zeitraum",
  "Previous period": "Vorheriger Zeitraum",
  to: "bis",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Ganztägige und mehrtägige Ereignisse",
  "Link to {{n}} more events on {{date}}": "Link zu {{n}} weiteren Ereignissen am {{date}}",
  "Link to 1 more event on {{date}}": "Link zu 1 weiteren Ereignis am {{date}}"
}, po = {
  ...vo,
  ...ho
}, fo = {
  Date: "Date",
  "MM/DD/YYYY": "MM/DD/YYYY",
  "Next month": "Next month",
  "Previous month": "Previous month",
  "Choose Date": "Choose Date"
}, mo = {
  Today: "Today",
  Month: "Month",
  Week: "Week",
  Day: "Day",
  "Select View": "Select View",
  events: "events",
  event: "event",
  "No events": "No events",
  "Next period": "Next period",
  "Previous period": "Previous period",
  to: "to",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Full day- and multiple day events",
  "Link to {{n}} more events on {{date}}": "Link to {{n}} more events on {{date}}",
  "Link to 1 more event on {{date}}": "Link to 1 more event on {{date}}"
}, yo = {
  ...fo,
  ...mo
}, Do = {
  Date: "Data",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Mese successivo",
  "Previous month": "Mese precedente",
  "Choose Date": "Scegli la data"
}, ko = {
  Today: "Oggi",
  Month: "Mese",
  Week: "Settimana",
  Day: "Giorno",
  "Select View": "Seleziona la vista",
  events: "eventi",
  event: "evento",
  "No events": "Nessun evento",
  "Next period": "Periodo successivo",
  "Previous period": "Periodo precedente",
  to: "a",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Eventi della giornata e plurigiornalieri",
  "Link to {{n}} more events on {{date}}": "Link a {{n}} eventi in più il {{date}}",
  "Link to 1 more event on {{date}}": "Link a 1 evento in più il {{date}}"
}, go = {
  ...Do,
  ...ko
}, bo = {
  Date: "Date",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Next month",
  "Previous month": "Previous month",
  "Choose Date": "Choose Date"
}, Po = {
  Today: "Today",
  Month: "Month",
  Week: "Week",
  Day: "Day",
  "Select View": "Select View",
  events: "events",
  event: "event",
  "No events": "No events",
  "Next period": "Next period",
  "Previous period": "Previous period",
  to: "to",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Full day- and multiple day events",
  "Link to {{n}} more events on {{date}}": "Link to {{n}} more events on {{date}}",
  "Link to 1 more event on {{date}}": "Link to 1 more event on {{date}}"
}, So = {
  ...bo,
  ...Po
}, wo = {
  Date: "Datum",
  "MM/DD/YYYY": "ÅÅÅÅ-MM-DD",
  "Next month": "Nästa månad",
  "Previous month": "Föregående månad",
  "Choose Date": "Välj datum"
}, Mo = {
  Today: "Idag",
  Month: "Månad",
  Week: "Vecka",
  Day: "Dag",
  "Select View": "Välj vy",
  events: "händelser",
  event: "händelse",
  "No events": "Inga händelser",
  "Next period": "Nästa period",
  "Previous period": "Föregående period",
  to: "till",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Heldags- och flerdagshändelser",
  "Link to {{n}} more events on {{date}}": "Länk till {{n}} fler händelser den {{date}}",
  "Link to 1 more event on {{date}}": "Länk till 1 händelse till den {{date}}"
}, Yo = {
  ...wo,
  ...Mo
}, No = {
  Date: "日期",
  "MM/DD/YYYY": "年/月/日",
  "Next month": "下个月",
  "Previous month": "上个月",
  "Choose Date": "选择日期"
}, xo = {
  Today: "今天",
  Month: "月",
  Week: "周",
  Day: "日",
  "Select View": "选择视图",
  events: "场活动",
  event: "活动",
  "No events": "没有活动",
  "Next period": "下一段时间",
  "Previous period": "上一段时间",
  to: "至",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "全天和多天活动",
  "Link to {{n}} more events on {{date}}": "链接到{{date}}上的{{n}}个更多活动",
  "Link to 1 more event on {{date}}": "链接到{{date}}上的1个更多活动"
}, Eo = {
  ...No,
  ...xo
}, Lo = {
  Date: "日期",
  "MM/DD/YYYY": "年/月/日",
  "Next month": "下個月",
  "Previous month": "上個月",
  "Choose Date": "選擇日期"
}, To = {
  Today: "今天",
  Month: "月",
  Week: "周",
  Day: "日",
  "Select View": "選擇檢視模式",
  events: "場活動",
  event: "活動",
  "No events": "沒有活動",
  "Next period": "下一段時間",
  "Previous period": "上一段時間",
  to: "到",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "全天和多天活動",
  "Link to {{n}} more events on {{date}}": "連接到{{date}}上的{{n}}個更多活動",
  "Link to 1 more event on {{date}}": "連接到{{date}}上的1個更多活動"
}, Co = {
  ...Lo,
  ...To
}, Oo = {
  Date: "日付",
  "MM/DD/YYYY": "年/月/日",
  "Next month": "次の月",
  "Previous month": "前の月",
  "Choose Date": "日付を選択"
}, $o = {
  Today: "今日",
  Month: "月",
  Week: "週",
  Day: "日",
  "Select View": "ビューを選択",
  events: "イベント",
  event: "イベント",
  "No events": "イベントなし",
  "Next period": "次の期間",
  "Previous period": "前の期間",
  to: "から",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "終日および複数日イベント",
  "Link to {{n}} more events on {{date}}": "{{date}} に{{n}}件のイベントへのリンク",
  "Link to 1 more event on {{date}}": "{{date}} に1件のイベントへのリンク"
}, Ao = {
  ...Oo,
  ...$o
}, Fo = {
  Date: "Дата",
  "MM/DD/YYYY": "ММ/ДД/ГГГГ",
  "Next month": "Следующий месяц",
  "Previous month": "Прошлый месяц",
  "Choose Date": "Выберите дату"
}, Wo = {
  Today: "Сегодня",
  Month: "Месяц",
  Week: "Неделя",
  Day: "День",
  "Select View": "Выберите вид",
  events: "события",
  event: "событие",
  "No events": "Нет событий",
  "Next period": "Следующий период",
  "Previous period": "Прошлый период",
  to: "по",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "События на целый день и несколько дней подряд",
  "Link to {{n}} more events on {{date}}": "Ссылка на {{n}} дополнительных событий на {{date}}",
  "Link to 1 more event on {{date}}": "Ссылка на 1 дополнительное событие на {{date}}"
}, Uo = {
  ...Fo,
  ...Wo
}, Vo = {
  Date: "일자",
  "MM/DD/YYYY": "년/월/일",
  "Next month": "다음 달",
  "Previous month": "이전 달",
  "Choose Date": "날짜 선택"
}, Io = {
  Today: "오늘",
  Month: "월",
  Week: "주",
  Day: "일",
  "Select View": "보기 선택",
  events: "일정들",
  event: "일정",
  "No events": "일정 없음",
  "Next period": "다음",
  "Previous period": "이전",
  to: "부터",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "종일 및 복수일 일정",
  "Link to {{n}} more events on {{date}}": "{{date}}에 {{n}}개 이상의 이벤트로 이동",
  "Link to 1 more event on {{date}}": "{{date}}에 1개 이상의 이벤트로 이동"
}, Ro = {
  ...Vo,
  ...Io
}, jo = {
  Date: "Date",
  "MM/DD/YYYY": "JJ/MM/AAAA",
  "Next month": "Mois suivant",
  "Previous month": "Mois précédent",
  "Choose Date": "Choisir une date"
}, Ho = {
  Today: "Aujourd'hui",
  Month: "Mois",
  Week: "Semaine",
  Day: "Jour",
  "Select View": "Choisir la vue",
  events: "événements",
  event: "événement",
  "No events": "Aucun événement",
  "Next period": "Période suivante",
  "Previous period": "Période précédente",
  to: "à",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Événements d'une ou plusieurs journées",
  "Link to {{n}} more events on {{date}}": "Lien vers {{n}} autres événements le {{date}}",
  "Link to 1 more event on {{date}}": "Lien vers 1 autre événement le {{date}}"
}, zo = {
  ...jo,
  ...Ho
}, Bo = {
  Date: "Dato",
  "MM/DD/YYYY": "ÅÅÅÅ-MM-DD",
  "Next month": "Næste måned",
  "Previous month": "Foregående måned",
  "Choose Date": "Vælg dato"
}, Ko = {
  Today: "I dag",
  Month: "Måned",
  Week: "Uge",
  Day: "Dag",
  "Select View": "Vælg visning",
  events: "begivenheder",
  event: "begivenhed",
  "No events": "Ingen begivenheder",
  "Next period": "Næste periode",
  "Previous period": "Forgående periode",
  to: "til",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Heldagsbegivenheder og flerdagsbegivenheder",
  "Link to {{n}} more events on {{date}}": "Link til {{n}} flere begivenheder den {{date}}",
  "Link to 1 more event on {{date}}": "Link til 1 mere begivenhed den {{date}}"
}, Go = {
  ...Bo,
  ...Ko
}, Jo = {
  Date: "Data",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Następny miesiąc",
  "Previous month": "Poprzedni miesiąc",
  "Choose Date": "Wybiewrz datę"
}, Zo = {
  Today: "Dzisiaj",
  Month: "Miesiąc",
  Week: "Tydzień",
  Day: "Dzień",
  "Select View": "Wybierz widok",
  events: "wydarzenia",
  event: "wydarzenie",
  "No events": "Brak wydarzeń",
  "Next period": "Następny okres",
  "Previous period": "Poprzedni okres",
  to: "do",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Wydarzenia całodniowe i wielodniowe",
  "Link to {{n}} more events on {{date}}": "Link do {{n}} kolejnych wydarzeń w dniu {{date}}",
  "Link to 1 more event on {{date}}": "Link do 1 kolejnego wydarzenia w dniu {{date}}"
}, qo = {
  ...Jo,
  ...Zo
}, Xo = {
  Date: "Fecha",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Siguiente mes",
  "Previous month": "Mes anterior",
  "Choose Date": "Seleccione una fecha"
}, Qo = {
  Today: "Hoy",
  Month: "Mes",
  Week: "Semana",
  Day: "Día",
  "Select View": "Seleccione una vista",
  events: "eventos",
  event: "evento",
  "No events": "Sin eventos",
  "Next period": "Siguiente período",
  "Previous period": "Período anterior",
  to: "a",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Día completo y eventos de múltiples días",
  "Link to {{n}} more events on {{date}}": "Enlace a {{n}} eventos más el {{date}}",
  "Link to 1 more event on {{date}}": "Enlace a 1 evento más el {{date}}"
}, ei = {
  ...Xo,
  ...Qo
}, ti = {
  Today: "Vandaag",
  Month: "Maand",
  Week: "Week",
  Day: "Dag",
  "Select View": "Kies weergave",
  events: "gebeurtenissen",
  event: "gebeurtenis",
  "No events": "Geen gebeurtenissen",
  "Next period": "Volgende periode",
  "Previous period": "Vorige periode",
  to: "tot",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Evenementen van een hele dag en meerdere dagen",
  "Link to {{n}} more events on {{date}}": "Link naar {{n}} meer evenementen op {{date}}",
  "Link to 1 more event on {{date}}": "Link naar 1 meer evenement op {{date}}"
}, ni = {
  Date: "Datum",
  "MM/DD/YYYY": "DD-MM-JJJJ",
  "Next month": "Volgende maand",
  "Previous month": "Vorige maand",
  "Choose Date": "Kies datum"
}, oi = {
  ...ni,
  ...ti
}, ii = {
  Date: "Data",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Mês seguinte",
  "Previous month": "Mês anterior",
  "Choose Date": "Escolha uma data"
}, ri = {
  Today: "Hoje",
  Month: "Mês",
  Week: "Semana",
  Day: "Dia",
  "Select View": "Selecione uma visualização",
  events: "eventos",
  event: "evento",
  "No events": "Sem eventos",
  "Next period": "Período seguinte",
  "Previous period": "Período anterior",
  to: "a",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Dia inteiro e eventos de vários dias",
  "Link to {{n}} more events on {{date}}": "Link para mais {{n}} eventos em {{date}}",
  "Link to 1 more event on {{date}}": "Link para mais 1 evento em {{date}}"
}, ai = {
  ...ii,
  ...ri
}, si = {
  Date: "Dátum",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Ďalší mesiac",
  "Previous month": "Predchádzajúci mesiac",
  "Choose Date": "Vyberte dátum"
}, li = {
  Today: "Dnes",
  Month: "Mesiac",
  Week: "Týždeň",
  Day: "Deň",
  "Select View": "Vyberte zobrazenie",
  events: "udalosti",
  event: "udalosť",
  "No events": "Žiadne udalosti",
  "Next period": "Ďalšie obdobie",
  "Previous period": "Predchádzajúce obdobie",
  to: "do",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Celodenné a viacdňové udalosti",
  "Link to {{n}} more events on {{date}}": "Odkaz na {{n}} ďalších udalostí dňa {{date}}",
  "Link to 1 more event on {{date}}": "Odkaz na 1 ďalšiu udalosť dňa {{date}}"
}, ui = {
  ...si,
  ...li
}, ci = {
  Date: "Датум",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Следен месец",
  "Previous month": "Претходен месец",
  "Choose Date": "Избери Датум"
}, di = {
  Today: "Денес",
  Month: "Месец",
  Week: "Недела",
  Day: "Ден",
  "Select View": "Избери Преглед",
  events: "настани",
  event: "настан",
  "No events": "Нема настани",
  "Next period": "Следен период",
  "Previous period": "Претходен период",
  to: "до",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Целодневни и повеќедневни настани",
  "Link to {{n}} more events on {{date}}": "Линк до {{n}} повеќе настани на {{date}}",
  "Link to 1 more event on {{date}}": "Линк до 1 повеќе настан на {{date}}"
}, _i = {
  ...ci,
  ...di
}, vi = {
  Date: "Tarih",
  "MM/DD/YYYY": "GG/AA/YYYY",
  "Next month": "Sonraki ay",
  "Previous month": "Önceki ay",
  "Choose Date": "Tarih Seç"
}, hi = {
  Today: "Bugün",
  Month: "Aylık",
  Week: "Haftalık",
  Day: "Günlük",
  "Select View": "Görünüm Seç",
  events: "etkinlikler",
  event: "etkinlik",
  "No events": "Etkinlik yok",
  "Next period": "Sonraki dönem",
  "Previous period": "Önceki dönem",
  to: "dan",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Tüm gün ve çoklu gün etkinlikleri",
  "Link to {{n}} more events on {{date}}": "{{date}} tarihinde {{n}} etkinliğe bağlantı",
  "Link to 1 more event on {{date}}": "{{date}} tarihinde 1 etkinliğe bağlantı"
}, pi = {
  ...vi,
  ...hi
}, fi = {
  Date: "Датасы",
  "MM/DD/YYYY": "АА/КК/ЖЖЖЖ",
  "Next month": "Кийинки ай",
  "Previous month": "Өткөн ай",
  "Choose Date": "Күндү тандаңыз"
}, mi = {
  Today: "Бүгүн",
  Month: "Ай",
  Week: "Апта",
  Day: "Күн",
  "Select View": "Көрүнүштү тандаңыз",
  events: "Окуялар",
  event: "Окуя",
  "No events": "Окуя жок",
  "Next period": "Кийинки мезгил",
  "Previous period": "Өткөн мезгил",
  to: "чейин",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Күн бою жана бир нече күн катары менен болгон окуялар",
  "Link to {{n}} more events on {{date}}": "{{date}} күнүндө {{n}} окуяга байланыш",
  "Link to 1 more event on {{date}}": "{{date}} күнүндө 1 окуяга байланыш"
}, yi = {
  ...fi,
  ...mi
}, Di = {
  Date: "Tanggal",
  "MM/DD/YYYY": "DD.MM.YYYY",
  "Next month": "Bulan depan",
  "Previous month": "Bulan sebelumnya",
  "Choose Date": "Pilih tanggal"
}, ki = {
  Today: "Hari Ini",
  Month: "Bulan",
  Week: "Minggu",
  Day: "Hari",
  "Select View": "Pilih tampilan",
  events: "Acara",
  event: "Acara",
  "No events": "Tidak ada acara",
  "Next period": "Periode selanjutnya",
  "Previous period": "Periode sebelumnya",
  to: "sampai",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Sepanjang hari dan acara beberapa hari ",
  "Link to {{n}} more events on {{date}}": "Tautan ke {{n}} acara lainnya pada {{date}}",
  "Link to 1 more event on {{date}}": "Tautan ke 1 acara lainnya pada {{date}}"
}, gi = {
  ...Di,
  ...ki
}, bi = {
  Date: "Datum",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Další měsíc",
  "Previous month": "Předchozí měsíc",
  "Choose Date": "Vyberte datum"
}, Pi = {
  Today: "Dnes",
  Month: "Měsíc",
  Week: "Týden",
  Day: "Den",
  "Select View": "Vyberte zobrazení",
  events: "události",
  event: "událost",
  "No events": "Žádné události",
  "Next period": "Příští období",
  "Previous period": "Předchozí období",
  to: "do",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Celodenní a vícedenní události",
  "Link to {{n}} more events on {{date}}": "Odkaz na {{n}} dalších událostí dne {{date}}",
  "Link to 1 more event on {{date}}": "Odkaz na 1 další událost dne {{date}}"
}, Si = {
  ...bi,
  ...Pi
}, wi = {
  Date: "Kuupäev",
  "MM/DD/YYYY": "PP.KK.AAAA",
  "Next month": "Järgmine kuu",
  "Previous month": "Eelmine kuu",
  "Choose Date": "Vali kuupäev"
}, Mi = {
  Today: "Täna",
  Month: "Kuu",
  Week: "Nädal",
  Day: "Päev",
  "Select View": "Vali vaade",
  events: "sündmused",
  event: "sündmus",
  "No events": "Pole sündmusi",
  "Next period": "Järgmine periood",
  "Previous period": "Eelmine periood",
  to: "kuni",
  "Full day- and multiple day events": "Täispäeva- ja mitmepäevasündmused",
  "Link to {{n}} more events on {{date}}": "Link {{n}} rohkematele sündmustele kuupäeval {{date}}",
  "Link to 1 more event on {{date}}": "Link ühele lisasündmusele kuupäeval {{date}}"
}, Yi = {
  ...wi,
  ...Mi
}, Ni = {
  Date: "Дата",
  "MM/DD/YYYY": "ММ/ДД/РРРР",
  "Next month": "Наступний місяць",
  "Previous month": "Минулий місяць",
  "Choose Date": "Виберіть дату"
}, xi = {
  Today: "Сьогодні",
  Month: "Місяць",
  Week: "Тиждень",
  Day: "День",
  "Select View": "Виберіть вигляд",
  events: "події",
  event: "подія",
  "No events": "Немає подій",
  "Next period": "Наступний період",
  "Previous period": "Минулий період",
  to: "по",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Події на цілий день і кілька днів поспіль",
  "Link to {{n}} more events on {{date}}": "Посилання на {{n}} додаткові події на {{date}}",
  "Link to 1 more event on {{date}}": "Посилання на 1 додаткову подію на {{date}}"
}, Ei = {
  ...Ni,
  ...xi
}, Li = {
  Date: "Datum",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Sledeći mesec",
  "Previous month": "Prethodni mesec",
  "Choose Date": "Izaberite datum"
}, Ti = {
  Today: "Danas",
  Month: "Mesec",
  Week: "Nedelja",
  Day: "Dan",
  "Select View": "Odaberite pregled",
  events: "Događaji",
  event: "Događaj",
  "No events": "Nema događaja",
  "Next period": "Naredni period",
  "Previous period": "Prethodni period",
  to: "do",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Celodnevni i višednevni događaji",
  "Link to {{n}} more events on {{date}}": "Link do još {{n}} događaja na {{date}}",
  "Link to 1 more event on {{date}}": "Link do jednog događaja na {{date}}"
}, Ci = {
  ...Li,
  ...Ti
};
class Oi extends Error {
  constructor(t) {
    super(`Invalid locale: ${t}`);
  }
}
const $i = (e, t) => (n, o) => {
  if (!/^[a-z]{2}-[A-Z]{2}$/.test(e.value) && e.value !== "sr-Latn-RS")
    throw new Oi(e.value);
  const i = e.value.replaceAll("-", ""), r = t[i];
  if (!r)
    return n;
  let a = r[n] || n;
  return Object.keys(o || {}).forEach((s) => {
    const u = String(o == null ? void 0 : o[s]);
    u && (a = a.replace(`{{${s}}}`, u));
  }), a;
}, Ai = {
  Date: "Data",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Següent mes",
  "Previous month": "Mes anterior",
  "Choose Date": "Selecciona una data"
}, Fi = {
  Today: "Avui",
  Month: "Mes",
  Week: "Setmana",
  Day: "Dia",
  "Select View": "Selecciona una vista",
  events: "Esdeveniments",
  event: "Esdeveniment",
  "No events": "Sense esdeveniments",
  "Next period": "Següent període",
  "Previous period": "Període anterior",
  to: "a",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Esdeveniments de dia complet i de múltiples dies",
  "Link to {{n}} more events on {{date}}": "Enllaç a {{n}} esdeveniments més el {{date}}",
  "Link to 1 more event on {{date}}": "Enllaç a 1 esdeveniment més el {{date}}"
}, Wi = {
  ...Ai,
  ...Fi
}, Ui = {
  Date: "Датум",
  "MM/DD/YYYY": "DD/MM/YYYY",
  "Next month": "Следећи месец",
  "Previous month": "Претходни месец",
  "Choose Date": "Изаберите Датум"
}, Vi = {
  Today: "Данас",
  Month: "Месец",
  Week: "Недеља",
  Day: "Дан",
  "Select View": "Изаберите преглед",
  events: "Догађаји",
  event: "Догађај",
  "No events": "Нема догађаја",
  "Next period": "Следећи период",
  "Previous period": "Претходни период",
  to: "да",
  // as in 2/1/2020 to 2/2/2020
  "Full day- and multiple day events": "Целодневни и вишедневни догађаји",
  "Link to {{n}} more events on {{date}}": "Линк до још {{n}} догађаја на {{date}}",
  "Link to 1 more event on {{date}}": "Линк до још 1 догађаја {{date}}"
}, Ii = {
  ...Ui,
  ...Vi
}, Ri = {
  deDE: po,
  enUS: yo,
  itIT: go,
  enGB: So,
  svSE: Yo,
  zhCN: Eo,
  zhTW: Co,
  jaJP: Ao,
  ruRU: Uo,
  koKR: Ro,
  frFR: zo,
  daDK: Go,
  mkMK: _i,
  plPL: qo,
  esES: ei,
  nlNL: oi,
  ptBR: ai,
  skSK: ui,
  trTR: pi,
  kyKG: yi,
  idID: gi,
  csCZ: Si,
  etEE: Yi,
  ukUA: Ei,
  caES: Wi,
  srLatnRS: Ci,
  srRS: Ii
}, ji = (e = {}) => {
  const t = new _o().withFirstDayOfWeek(e.firstDayOfWeek).withLocale(e.locale).withMin(e.min).withMax(e.max).withPlacement(e.placement).withListeners(e.listeners).withStyle(e.style).withTeleportTo(e.teleportTo).withLabel(e.label).withName(e.name).withDisabled(e.disabled).build(), n = new oo().withConfig(t).build();
  return new uo().withConfig(t).withDatePickerState(so(t, e.selectedDate)).withTimeUnitsImpl(n).withTranslate($i(t.locale, Ri)).build();
}, Hi = (e) => {
  const t = ji(e);
  return new eo(t);
}, Ki = st({
  name: "SxDatePicker",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      default: () => ({
        listeners: {}
      })
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t, expose: n }) {
    const o = "sx" + Math.random().toString(36).substr(2, 9);
    let i;
    return n({
      setTheme: (a) => {
        i == null || i.setTheme(a);
      }
    }), Rt(() => e.modelValue, (a) => {
      (i == null ? void 0 : i.value) !== a && i && (i.value = a);
    }), jt(() => {
      i = Hi({
        ...e.config,
        listeners: {
          ...e.config.listeners,
          onChange: (a) => {
            t("update:modelValue", a);
          }
        },
        selectedDate: e.modelValue
      }), i.render(document.getElementById(o));
    }), () => J("div", {
      id: o,
      class: "sx-vue-date-picker-wrapper"
    });
  }
});
export {
  Bi as ScheduleXCalendar,
  Ki as SxDatePicker
};
